import { apiClient, apiGet, apiPost, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/files";

export const filesApi = {
  list: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}?${searchParams.toString()}`);
  },

  upload: (formData: FormData) => {
    return apiClient.post<{ file: Record<string, unknown> }>(BASE, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  getById: (id: string) => apiGet<{ file: Record<string, unknown> }>(`${BASE}/${id}`),

  download: (id: string) => apiGet<{ url: string; filename: string }>(`${BASE}/${id}/download`),

  delete: (id: string) => apiDelete<{ message: string }>(`${BASE}/${id}`),
};
